// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__8lhuz"};